// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see ExperimentActivateViewEvent
 */
export var ExperimentActivateView = function (_a) {
    var experimentId = _a.experimentId, variationId = _a.variationId, experimentSource = _a.experimentSource;
    return ({
        name: "Experiment Activate View",
        parameters: {
            cdf_entity: "Experiment",
            cdf_action: "Activate",
            experiment_id: experimentId !== undefined && experimentId !== null ? experimentId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variation_id: variationId !== undefined && variationId !== null ? variationId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            experiment_source: experimentSource !== undefined && experimentSource !== null ? experimentSource.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ExperimentActivateAssignEvent
 */
export var ExperimentActivateAssign = function (_a) {
    var experimentId = _a.experimentId, treatment = _a.treatment, source = _a.source;
    return ({
        name: "Experiment Activate Assign",
        parameters: {
            cdf_entity: "Experiment",
            cdf_action: "Activate",
            experiment_id: experimentId !== undefined && experimentId !== null ? experimentId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ExperimentActivateLatencyEvent
 */
export var ExperimentActivateLatency = function (_a) {
    var experimentId = _a.experimentId, actualLatencyMs = _a.actualLatencyMs, callLatencyMS = _a.callLatencyMS, appToken = _a.appToken, action = _a.action, configuredLatency = _a.configuredLatency, responseCode = _a.responseCode;
    return ({
        name: "Experiment Activate Latency",
        parameters: {
            cdf_entity: "Experiment",
            cdf_action: "Activate",
            experiment_id: experimentId !== undefined && experimentId !== null ? experimentId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            actualLatencyMs: actualLatencyMs !== undefined && actualLatencyMs !== null ? actualLatencyMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            callLatencyMS: callLatencyMS !== undefined && callLatencyMS !== null ? callLatencyMS.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            appToken: appToken !== undefined && appToken !== null ? appToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            configuredLatency: configuredLatency !== undefined && configuredLatency !== null ? configuredLatency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            responseCode: responseCode !== undefined && responseCode !== null ? responseCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
